"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getJwtUserInfo: ()=>getJwtUserInfo,
    jwtUserInfo: ()=>jwtUserInfo,
    parseJwt: ()=>parseJwt
});
const index_js_namespaceObject = require("../domain-id/index.js");
const external_tool_js_namespaceObject = require("../tool.js");
const external_async_jwt_service_js_namespaceObject = require("./async-jwt.service.js");
const external_jwt_constant_js_namespaceObject = require("./jwt.constant.js");
const core_lib_namespaceObject = require("@bytecloud/core-lib");
const parseJwt = (token)=>(0, core_lib_namespaceObject.parseJwt)(token);
const getJwtUserInfo = async (uniqueKey)=>{
    const token = await external_async_jwt_service_js_namespaceObject.bytecloudAsyncJwtService.getJwt(null != uniqueKey ? uniqueKey : (0, external_tool_js_namespaceObject.tryCatch)(()=>(0, index_js_namespaceObject.getCurrentDomainID)(), (error)=>{
        console.error({
            message: error.message,
            position: 'getJwtUserInfo',
            context: {
                currentDomainID: index_js_namespaceObject.currentDomainID
            }
        });
        throw error;
    }));
    return parseJwt(token);
};
const jwtUserInfo = (()=>{
    try {
        const token = window.localStorage.getItem(external_jwt_constant_js_namespaceObject.JwtStorageKey) || '';
        return parseJwt(token);
    } catch (error) {
        return null;
    }
})();
exports.getJwtUserInfo = __webpack_exports__.getJwtUserInfo;
exports.jwtUserInfo = __webpack_exports__.jwtUserInfo;
exports.parseJwt = __webpack_exports__.parseJwt;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "getJwtUserInfo",
    "jwtUserInfo",
    "parseJwt"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
